module.exports = __webpack_public_path__ + "static/assets/39916645f3010f5b997231c75b9a6712.svg";